<template>
<div id="invoice-list-loading">
  <vs-table :data="dataTable">
    <template slot="thead">
      <th-sort  :style="{ textAlign:'left'}"  width="10vw" :text="$t('client')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'left'}"  width="10vw" :text="$t('vendor')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'center'}"  width="10vw" :text="$t('folio')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'center'}"  width="10vw" :text="$t('currency')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'right'}"  width="10vw" :text="$t('subtotal')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'right'}"  width="10vw" text="IVA"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'right'}"  width="10vw" :text="$t('total')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'right'}"  width="15vw" :text="$t('exchange_rate')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'right'}"  width="10vw" text="BI Total USD"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'center'}"  width="10vw" :text="$t('date')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'left'}"  width="10vw" :text="$t('status')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'center'}"  width="10vw" text="InvoiceId"         column="cl.ClientName" @sort="handleClickSort"/>
      <th-sort  :style="{ textAlign:'center'}"  width="10vw" :text="$t('week')|capitalize"         column="cl.ClientName" @sort="handleClickSort"/>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td style="width:'10vw'"  class="text-left" >{{tr.ClientName}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-left" >{{tr.VendorName}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-center" >{{tr.Folio}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-center" >{{tr.CurrencyId}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-right" >$ {{formatNumber(tr.Subtotal,2)}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-right" >$ {{formatNumber(tr.IVA,2)}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-right" >$ {{formatNumber(tr.Total,2)}}</vs-td>
          <vs-td style="width:'15vw'"  class="text-right" >$ {{formatNumber(tr.ExchangeRate,2)}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-right" >$ {{formatNumber(tr.BI_TotalUSD,2)}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-center" >{{formatDate(tr.ExpenseDate)}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-left" >{{tr.StatusName}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-center" >{{tr.InvoiceId}}</vs-td>
          <vs-td style="width:'10vw'"  class="text-center" >{{tr.Week}}</vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div
            v-if="data.length"
            v-observe-visibility="infiniteHandler"
          ></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  </div>
</template>

<script>
import ThSort from '@/views/components/ThSort.vue'
export default {
  components: { 
    ThSort
  },
  props: {
    dataTable: {
      type: Array,
      default: () => []
    },
    reSearch: {
      type: Number,
      default: 0
    },
    searchValue: {
      type: String,
      default: ''
    },
    ClientId: {
      type: Array,
      default: () => []
    },
    PeriodId: {
      type: Array,
      default: () => []
    },
    sort: {
      type: Array,
      default: () => ['DESC']
    },
    sortBy: {
      type: Array,
      default: () => ['p.Year']
    }
  },
  data() {
    return {
      allowEditing: false,
      lastPage:1,
      params: {
        types: [2],
        page: 1,
        search:this.searchValue,
        ClientId:this.ClientId,
        PeriodId:this.PeriodId,
        sort:this.sort,
        sortBy:this.sortBy
      }
    }
  },
  computed: {
      
  },
  watch:{
  
  },
  mounted(){
  
  },
  
  methods: {
    init(){
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      //emit load more
    }
  },
}
</script>

<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope='row']) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.vx-card__body {
  padding: 10px 0px !important;
}

.vs-table--not-data {
  display: none !important;
}

.sm-size {
  font-size: 12px;
}

.comment-truncate {
  overflow-wrap: break-word;
}
.vx-card__title h4 {
  margin-bottom: 2vh;
}
.icon-action {
  display: inline-block;
}
</style>